(function($){
  $(document).ready(function(){
    let showSizeGuideNote = false;
    const splitPoint = productType.includes('KIDS-キッズ') ? 3 : 2;
    const parts = productType.split('/');
    if (parts.length >= splitPoint) {
      // 深い階層のカテゴリを削除
      parts.splice(splitPoint);
      productType = parts.join('/');
    } else {
      // 性別の下のカテゴリまでしかない場合は処理なし
    }
    let sizeKey = '';
    let showSizeGuide = () => {
      const selectedSizeText = $('.variant-picker__option-info').last().next().find('button.select').text().trim().toUpperCase();
      if (selectedSizeText.match('^XXXS$|^3XS$|^3XS[-/]XXS$|^XXXS[-/]XXS$|^XXS$|^XXS[-/]XS$|^XS$|^XS[-/]S$|^S$|^S[-/]M$|^M$|^M[-/]L$|^L$|^L[-/]XL$|^XL$|^XL[-/]XXL$|^XXL$|^XXL[-/]XXXL$|^XXL[-/]3XL$|^XXXL$|^3XL$|^XXXL[-/]4XL$|^3XL[-/]4XL$|^4XL$|^4XL[-/]5XL$|^5XL$')) {
        selectedSizeKey = selectedSizeText;
      } else {
          selectedSizeKey = productType + selectedSizeText;
      }
      if (sizeMap[selectedSizeKey] !== undefined && sizeMap[selectedSizeKey] !== '') {
        $('.variant-picker__option-info').last().next().find('button.select span')
          .append(
            $('<span>')
              .addClass('size-guide')
              .css('fontSize', '11px')
              .css('marginLeft', '8px')
              .text(`(${sizeMaster[sizeMap[selectedSizeKey]]})`)
          );
          showSizeGuideNote = true;
      }
      $('.popover__value-list').last().find('span').each(function() {
        const sizeText = $(this).text().toUpperCase();
        if (sizeText.match('^XXXS$|^3XS$|^3XS[-/]XXS$|^XXXS[-/]XXS$|^XXS$|^XXS[-/]XS$|^XS$|^XS[-/]S$|^S$|^S[-/]M$|^M$|^M[-/]L$|^L$|^L[-/]XL$|^XL$|^XL[-/]XXL$|^XXL$|^XXL[-/]XXXL$|^XXL[-/]3XL$|^XXXL$|^3XL$|^XXXL[-/]4XL$|^3XL[-/]4XL$|^4XL$|^4XL[-/]5XL$|^5XL$')) {
          sizeKey = sizeText;
        } else {
          sizeKey = productType + sizeText;
        }
        if (sizeMap[sizeKey] !== undefined && sizeMap[sizeKey] !== '') {
          $(this)
            .append(
              $('<span>')
                .addClass('size-guide')
                .css('fontSize', '11px')
                .css('marginLeft', '8px')
                .text(`(${sizeMaster[sizeMap[sizeKey]]})`)
            );
            showSizeGuideNote = true;
        }
      });
      if (showSizeGuideNote && $('.size-guide-note').length === 0) {
        $('<span class="size-guide-note">')
          .css('fontSize', '12px')
          .css('marginTop', '8px')
          .text('()内のサイズは日本基準の参考サイズです。')
          .insertAfter($('.variant-picker').last());
      }
    };
    showSizeGuide();
    $(document).on('change', $('.popover__value-list').last().find('label'), function() {
      showSizeGuide();
    });
  });
})(jQuery);
